<template>
    <div>
        <!-- <div v-if="Names == ''">
            <Mainlayout></Mainlayout>
        </div>
        <div v-else>
            <MainlayoutLogin></MainlayoutLogin>
        </div> -->
        <Mainlayout></Mainlayout>
    
        <CCol sm="12" class="bg-FAFAFA">
            <CCol sm="12" style="width: 80%;background-size: cover; margin: auto;color: #fff" class="d-sm-down-none">
                <br /> <br /> <br /> <br /> <br />
                <CCard class="bg-white b-20 m-3" style="border:none;">
                    <CRow class="m-2">
                        <CCol sm="12">
                            <h3 class="custom-40px-500 text-center mt-3">Contact Us</h3>
                            <p class="custom-18px-400 text-center m-2">Thank you for your interest in Interviewrr! We're here to assist you in any way we can. Whether you have questions about our services,need technical support, or just want to say hello, please don't hesitate to reach out to us.</p>
                        </CCol>
                        <CCol sm="6">
                            <CCard class="bg-white mt-5 b-20 custom-line-border">
                                <h1 class="custom-header-title text-black text-left text-48px mt-5">
                                    <strong>Support</strong>
                                </h1>
                                <label class="custom-header-subtitle text-left text-16px p-40">Fill up the form and our team will get back to you with 24 hours.</label>
                                <CRow class="p-40 mb-20">
                                    <CCol sm="2"><img style="max-width:100%" src="../assets/img/bell.png" /></CCol>
                                    <CCol sm="10">
                                        <h5 class="text-16px text-black-dark mt-2">+6019 385 7722</h5>
                                    </CCol>
    
    
                                    <CCol sm="2" class="mt-2"><img style="max-width:100%" src="../assets/img/email.png" /></CCol>
                                    <CCol sm="10" class="mt-2">
                                        <h5 class="text-16px text-black-dark mt-2">contact@interviewrr.ai</h5>
                                    </CCol>
    
                                    <CCol sm="2" class="mt-2"><img style="max-width:100%" src="../assets/img/location.png" /></CCol>
                                    <CCol sm="10" class="mt-2">
                                        <h5 class="text-16px text-black-dark mt-2">The Square @ One City, T1-14-13, Jalan USJ 25/1C, 47650 Subang Jaya, Selangor</h5>
                                    </CCol>
    
                                </CRow>
                                <br /><br />
                            </CCard>
                        </CCol>
                        <CCol sm="6">
                            <CCard class="bg-white mt-5 p-40 b-20" style="border:none">
                                <label class="text-black-dark mt-3">Name</label>
                                <input type="text" class="custom-input-app b-50" v-model="Name" />
    
                                <label class="text-black-dark">Email</label>
                                <input type="text" class="custom-input-app b-50" v-model="Email" />
    
                                <label class="text-black-dark">Phone</label>
                                <input type="text" class="custom-input-app b-50" v-model="Phone" />
    
                                <label class="text-black-dark">How can we help?</label>
                                <CTextarea type="text" rows="9" v-model="Help" />
                                <div class="text-right mb-4">
                                    <CButton class="custom-border-purple text-white" style="width:40%"><span class="ml-2 mr-2" @click="insertHelp()">Send message</span></CButton>
                                </div>
    
                            </CCard>
                        </CCol>
                    </CRow>
                </CCard>
    
            </CCol>

            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff" class="d-md-none">
                <br /> <br /> <br /> <br /> <br />
                <CCard class="bg-white b-20 m-3" style="border:none;">
                    <CRow class="m-2">
                        <CCol sm="12">
                            <h3 class="custom-40px-500 text-center mt-3">Contact Us</h3>
                            <p class="custom-18px-400 text-center m-2">Thank you for your interest in Interviewrr! We're here to assist you in any way we can. Whether you have questions about our services,need technical support, or just want to say hello, please don't hesitate to reach out to us.</p>
                        </CCol>
                        <CCol sm="6">
                            <CCard class="bg-white mt-5 b-20 custom-line-border">
                                <h1 class="custom-header-title text-black text-left text-48px mt-5 ml-4">
                                    <strong>Support</strong>
                                </h1>
                                <label class="custom-header-subtitle text-left text-16px p-40">Fill up the form and our team will get back to you with 24 hours.</label>
                                <CRow class="p-40 mb-20">
                                    <CCol sm="2"><img style="max-width:100%" src="../assets/img/bell.png" /></CCol>
                                    <CCol sm="10">
                                        <h5 class="text-16px text-black-dark mt-2">+6019 385 7722</h5>
                                    </CCol>
    
    
                                    <CCol sm="2" class="mt-2"><img style="max-width:100%" src="../assets/img/email.png" /></CCol>
                                    <CCol sm="10" class="mt-2">
                                        <h5 class="text-16px text-black-dark mt-2">contact@interviewrr.ai</h5>
                                    </CCol>
    
                                    <CCol sm="2" class="mt-2"><img style="max-width:100%" src="../assets/img/location.png" /></CCol>
                                    <CCol sm="10" class="mt-2">
                                        <h5 class="text-16px text-black-dark mt-2">The Square @ One City, T1-14-13, Jalan USJ 25/1C, 47650 Subang Jaya, Selangor</h5>
                                    </CCol>
    
                                </CRow>
                                <br /><br />
                            </CCard>
                        </CCol>
                        <CCol sm="6">
                            <CCard class="bg-white mt-5 p-40 b-20" style="border:none">
                                <label class="text-black-dark mt-3">Name</label>
                                <input type="text" class="custom-input-app b-50" v-model="Name" />
    
                                <label class="text-black-dark">Email</label>
                                <input type="text" class="custom-input-app b-50" v-model="Email" />
    
                                <label class="text-black-dark">Phone</label>
                                <input type="text" class="custom-input-app b-50" v-model="Phone" />
    
                                <label class="text-black-dark">How can we help?</label>
                                <CTextarea type="text" rows="9" v-model="Help" />
                                <div class="text-right mb-4">
                                    <CButton class="custom-border-purple text-white"><span class="ml-2 mr-2" @click="insertHelp()">Send message</span></CButton>
                                </div>
    
                            </CCard>
                        </CCol>
                    </CRow>
                </CCard>
    
            </CCol>
    
        </CCol>
    
        <CCol sm="12" class="p-1" style="background-size: cover;color: #fff">
            <br /> <br /> <br />
            <CCol sm="12" lg="12">
                <div class="text-center p-2">
                    <CCol sm="12" style="width: 80%;margin: auto;" class="d-sm-down-none">
                        <div class="text-center" style="background-size: cover;border-radius: 20px;" :style="{ backgroundImage: `url(${backgroundUrNoArrow})` }">
                            <br />
                            <br /> <br /> <br />
                            <h1 class="custom-header-join text-white poppin-font text-48px mt-5">Subscribe Now for Free</h1>
                            <br />
                            <label class="custom-header-join-sub text-white">
                                                Sign up now for free and take the first step toward landing your dream job!
                                                                                </label>
                            <br />
                            <br /> <br /> <br />
                            <CButton class="button-Explore"><span class="ml-2 mr-2">Inquire</span></CButton>
                            <br />
                            <br /> <br /> <br />
                            <br />
                        </div>
                    </CCol>

                    <CCol sm="12" style="width: 100%;margin: auto;" class="d-md-none">
                        <div class="text-center" style="background-size: cover;border-radius: 20px;" :style="{ backgroundImage: `url(${backgroundUrNoArrow})` }">
                            <br />
                            <br /> <br /> <br />
                            <h1 class="custom-header-join text-white poppin-font text-48px mt-5">Subscribe Now for Free</h1>
                            <br />
                            <label class="custom-header-join-sub text-white">
                                                Sign up now for free and take the <br /> first step toward landing your dream job!
                                                                                </label>
                            <br />
                            <br /> <br /> <br />
                            <CButton class="button-Explore"><span class="ml-2 mr-2">Inquire</span></CButton>
                            <br />
                            <br /> <br /> <br />
                            <br />
                        </div>
                    </CCol>
                </div>
                <br /><br /><br />
            </CCol>
    
    
        </CCol>

        <div v-if="isLanguagePopupVisible2" class="popup-all backdrop-all">
        <div class="popup-all1">
            <!-- Popup content -->
            <div class="text-center">
                <img style="max-width: 100px" src="../assets/img/rightstar.png" />
                <h3 class="custom-32px-500 custom-24px-600 font-color-171717">Thank you for submitting the form</h3>
<h3 class="custom-16px-400 text-center">
    We are carefully reviewing your request and will notify you of the results within the next 2 days.
</h3>

            </div>

            <CButton class="custom-border-purple text-white" @click="closePopup1()" block><span class="ml-2 mr-2">Close</span></CButton>
            
        </div>
    </div>
    
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        MainlayoutLogin,
        Footerlayout
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,
            isLanguagePopupVisible2: false,
            Name: "",
            Email: "",
            Phone: "",
            Help: "",

            Names: "",

        };
    },
    created() {},
    mounted() {
        // const isAuth = this.UserAuth();
        //     if (isAuth) {
        //     this.GetInfoUser();
        // } else {
        //     this.loading = false; // If not authenticated, immediately set loading to false
        // }
},
    methods: {
        insertHelp() {
            const formData = new FormData();
            formData.append("name", this.Name);
            formData.append("email", this.Email);
            formData.append("phone", this.Phone);
            formData.append("help", this.Help);


            this.$API
                .post(this.$RegisterSupport, formData, )
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                    }
                    if (response.status == 200) {
                        this.isLanguagePopupVisible2 = true;
                        if (response.data.status !== 400) {
                            if (response.data.status !== 400) {


                                this.isLanguagePopupVisible2 = true;

                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }

                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });

        },
        closePopup1() {
            this.isLanguagePopupVisible2 = false
            this.$router.push("/");
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.Names = this.user.name;
                } else {
                    this.$router.push("ContactUs");
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                this.$router.push("ContactUs");
                console.error("Error fetching user info:", error);
            }
        },
    }

};
</script>
